import { Router, RouterModule } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { SelectModule } from 'primeng/select';
import { StyleClassModule } from 'primeng/styleclass';

import {  ShortNamePipe } from '@fitness-force/pipes/short-name'
import { ClientService } from '@fitness-force/api';
import { DrawerModule } from 'primeng/drawer';
import {  TranslateModule } from '@ngx-translate/core';
// import { FactoryHttpLoader } from '@fitness-force/shared';
// import { HttpClient } from '@angular/common/http';

// import { BasicInfoComponentModule } from 'libs/shared/src/lib/components/client-profile/basic-info-header/basic-info-header.component';


@Component({
  selector: 'client-info',
  templateUrl: './client-info.component.html',
  styleUrls: ['./client-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    AvatarModule,
    SelectModule,
    StyleClassModule,
    ShortNamePipe,
    PopoverModule,
    DrawerModule,
    TranslateModule
  ]
})
export class ClientInfoComponent implements OnInit {
  @Input() columnData = new BehaviorSubject([]);
  @Output() onAction = new EventEmitter();


  constructor(private router: Router, private clientService: ClientService) { }

  ngOnInit(): void {

  }

  showFullNameIntials() { }

  gotoClient(data: any) {
    this.onAction.emit({ action: 'showProfile', columnData: data });
  }

  clientStatus(client: any): string {
    if (client && client.status)
      return this.clientService.getClientStatusHtml(client.status.toString());
    else
      return '';
  }


}